// The filler's source, as TEXT: Vite's `?raw` hands over the file's bytes
// untouched, so the text the tests evaluate is byte-for-byte the text installed.
import fillerSource from './nzpvs-fill.js?raw';

/**
 * The CCAANZ → NZPVS filler bookmarklet (cca-uzt5).
 *
 * `nzpvs-fill.js` is ONE self-contained function expression (no imports, no
 * outside references), taking the page's `window`. The bookmark is that
 * expression called ONCE with `window`, behind `void`: a `javascript:` URL
 * whose result is a string REPLACES the page with that string, and `void`
 * makes the result undefined whatever the function returns. Percent-encoded
 * whole, so no character of the source can end the URL early.
 *
 * Installed from the vetting portal's Settings drawer (NzpvsFillerInstall.tsx),
 * never fetched by the Police page: there is no remote loader, so nothing the
 * portal serves later can change what runs there until the registrar drags
 * the link again.
 */

/**
 * The payload version this filler reads — the worker's NZPVS_PAYLOAD_VERSION,
 * copy.ts's VERSION and nzpvs-fill.js's own `VERSION`. It is also the ONLY way
 * an installed bookmark learns it is out of date, so ANY change to
 * nzpvs-fill.js bumps all four together (cca-lzcdm: bookmarklet.test.ts pins
 * the source's hash to this number).
 */
export const NZPVS_FILLER_VERSION = 3;

/**
 * The source as one expression: trimmed, and without the single trailing `;`
 * the repo's formatter adds to an expression statement. Left in, that `;`
 * would end the statement before the call and the filler would never run.
 */
export function fillerExpression(source: string): string {
  return source.trim().replace(/;$/, '');
}

/** The bookmark for a filler source: `javascript:` + the encoded single call. */
export function bookmarkletFrom(source: string): string {
  return `javascript:${encodeURIComponent(`void ${fillerExpression(source)}(window);`)}`;
}

/** The installed filler's source text. */
export const NZPVS_FILLER_SOURCE: string = fillerSource;

/** The bookmark the Settings link carries. */
export const NZPVS_BOOKMARKLET: string = bookmarkletFrom(fillerSource);
